export const SESSION_CART_KEY = 'in_use_cart_id';
export const IS_CART_MERGING_LOCAL_STORAGE_KEY = 'is_cart_merging';
